import React, { useRef } from "react";
import "./App.scss";
import Nav from "./components/nav/Nav.jsx";
import PhoneImg from "./img/phone/phone-capture-app-1.webp";
import BtcImg from "./img/coin-der.webp";
import EthImg from "./img/coin-iz.webp";
import IconCvu from "./img/logitos/cvu.webp";
import IconArbtj from "./img/logitos/arbitrajes.webp";
import IconAcci from "./img/logitos/acciones.webp";
import IconBonos from "./img/logitos/bonos.webp";
import IconCucio from "./img/logitos/cauciones.webp";
import IconMep from "./img/logitos/mep.webp";
import IconWall from "./img/logitos/wall-street.webp";
import IconOns from "./img/logitos/ons.webp";
import BtnWhatsapp from "./components/btnWhatsapp/BtnWhatsapp.jsx";
import CarouselPhone from "./components/CarouselPhone/CarouselPhone.jsx";
import BtnDownloadApp from "./components/btnDownload/BtnDownloadApp.jsx";

const App = () => {
  const carouselRef = useRef(null);

  const scrollCarousel = (direction) => {
    if (carouselRef.current) {
      const carousel = carouselRef.current;
      const firstCard = carousel.children[0];
      if (!firstCard) return;

      const scrollAmount = firstCard.offsetWidth + 20;

      carousel.scrollBy({ left: direction * scrollAmount, behavior: "smooth" });
    }
  };

  return (
    <div className="container-app">
      <Nav />
      <BtnWhatsapp />

      <div className="container-header">
        <h1 className="title-header">
          Imaginá una forma <br /> rápida y segura de usar tu plata
        </h1>
        <p className="subtitle-header">
          Con Terra podés enviar, recibir y mover tu dinero de manera simple y rápida.
        </p>

          <BtnDownloadApp/>
        
        <div className="container-img-phone">
          <img className="eth-img coin-img" src={EthImg} alt="eth-img" />
          <img className="btc-img coin-img" src={BtcImg} alt="btc-img" />
          <img className="phone-img" src={PhoneImg} alt="phone-app" />
        </div>
      </div>
      <div className="container-first-section">
        <h2 className="title-first-section" id="sobre">
          Con Terra todas las cosas se hacen a tu manera.
        </h2>
        <p className="subtitle-first-section">
          pensamos cada detalle para que tengas la mejor experiencia.
        </p>

        <div className="container-carousel-cards" ref={carouselRef}>
          <div className="card">
            <img src={IconCvu} alt="icon-cvu" />
            <h3>Tu CVU</h3>
            <p>
              Abrí tu cuenta sin vueltas. Obtené tu CVU para enviar, recibir y
              mover tu dinero fácilmente, todo desde tu celular.
            </p>
          </div>
          <div className="card">
            <img src={IconMep} alt="icon-billetera-virtual" />
            <h3>Billetera Virtual</h3>
            <p>
              Gestioná todo tu dinero desde un solo lugar. Consultá tu saldo
              disponible y movés tus pesos cuando quieras, las 24 horas.
            </p>
          </div>
          <div className="card">
            <img src={IconArbtj} alt="icon-enviar-dinero" />
            <h3>Enviar dinero</h3>
            <p>
              Transferí a cualquier CBU, CVU o Alias de forma instantánea y
              segura. Enviá plata a tus contactos en segundos, sin comisiones
              ocultas.
            </p>
          </div>
          <div className="card">
            <img src={IconAcci} alt="icon-pagar-qr" />
            <h3>Pagar con QR</h3>
            <p>
              Pagá y cobrá escaneando un código QR. Una forma rápida y práctica
              de operar en comercios o entre personas, sin usar efectivo.
            </p>
          </div>
          <div className="card">
            <img src={IconBonos} alt="icon-contactos" />
            <h3>Contactos</h3>
            <p>
              Guardá tus contactos frecuentes y transferí más rápido. Buscá por
              nombre o apellido y enviá dinero sin volver a cargar datos.
            </p>
          </div>
          <div className="card">
            <img src={IconCucio} alt="icon-historial" />
            <h3>Historial</h3>
            <p>
              Llevá el control de tus movimientos del día y anteriores. Revisá
              cada operación con el detalle completo, cuando lo necesites.
            </p>
          </div>
          <div className="card">
            <img src={IconOns} alt="icon-alias" />
            <h3>Tu Alias</h3>
            <p>
              Personalizá tu alias para recibir transferencias fácilmente.
              Compartilo y que te envíen dinero sin complicaciones.
            </p>
          </div>
          <div className="card">
            <img src={IconWall} alt="icon-notificaciones" />
            <h3>Notificaciones</h3>
            <p>
              Enterate al instante de cada movimiento de tu cuenta. Recibí
              avisos en tiempo real de tus ingresos, pagos y transferencias.
            </p>
          </div>
        </div>
        <div className="container-btn-carousel">
          <button className="btn-arrow" onClick={() => scrollCarousel(-1)}>
            <svg
              className="icon-arrow icoar-left"
              data-slot="icon"
              aria-hidden="true"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clip-rule="evenodd"
                d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                fill-rule="evenodd"
              ></path>
            </svg>
          </button>
          <button className="btn-arrow" onClick={() => scrollCarousel(1)}>
            <svg
              className="icon-arrow icoar-right"
              data-slot="icon"
              aria-hidden="true"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clip-rule="evenodd"
                d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                fill-rule="evenodd"
              ></path>
            </svg>
          </button>
        </div>
      </div>
      <div className="container-second-section">
        <h2 className="title-second-section" id="wallet">
          Terra simplifica tu billetera digital para que manejar tu plata sea
          mas simple todos los dias.
        </h2>
        <p className="subtitle-second-section">
          Nos adaptamos a tu forma de moverte: envia, recibi y paga con QR
          cuando quieras, desde una app rapida y segura.
        </p>
        <div className="secon-section-container-screen-phone-box">
          <CarouselPhone />
        </div>
      </div>

      <div className="container-enterprise-link" id="empresa">
        <div className="enterprise-content">
          <div className="enterprise-text">
            <h2 className="enterprise-title">Simplifica tu negocio</h2>
            <p className="enterprise-description">Creá tu cuenta de empresa y accedé a todas las herramientas que necesitas para gestionar tus finanzas de forma segura y eficiente.</p>
            
            <div className="enterprise-features">
              <div className="feature-item">
                <div className="feature-icon">💳</div>
                <div className="feature-text">
                  <h3>CVU Empresarial</h3>
                  <p>Se te genera un CVU único para recibir pagos y transferencias directas.</p>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">📱</div>
                <div className="feature-text">
                  <h3>Pagos con QR</h3>
                  <p>Genera QR dinámicos para cobrar de forma instantánea desde cualquier lugar.</p>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">✓</div>
                <div className="feature-text">
                  <h3>Recepción de Pagos</h3>
                  <p>Recibe pagos por QR con confirmación inmediata y sin comisiones ocultas.</p>
                </div>
              </div>
            </div>

            <button className="enterprise-cta-btn" onClick={() => window.location.href = 'https://onboarding-terra.vercel.app'}>Haz tu cuenta de empresa</button>
          </div>
          <div className="enterprise-decoration">
            <div className="gradient-circle circle-1"></div>
            <div className="gradient-circle circle-2"></div>
          </div>
        </div>
      </div>


      <div className="container-form">
          <div className="container-txt-form-contact" id="ayuda">
            <h2 className="title-form-contact">Estamos a un click de vos</h2>
            <p className="subtitle-form-contact">Enviános un mensaje, queremos saber que necesitas. Vos nos importás.</p>
          </div>
          <form action="post">
            <div className="container-input-text-mail">
              <input type="text" name="name" placeholder="Nombre" id="" />
              <span class="input-border"></span>
              <input type="email" name="email" placeholder="Email" id="" />
              <span class="input-border"></span>
            </div>
            <textarea name="message" placeholder="Mensaje" id=""></textarea>
            <button type="submit" class="submit-btn">Enviar Mensaje</button> 
          </form>
      </div>

      <footer id="download-section">
        <div className="container-footer">
          <div className="container-copyr-buttons-apps">
            <div className="container-copyr">
              <h3>© Terra Blockchain SAS, 2025. Todos los derechos reservados.</h3>
              <p>
                 CUIT: 30-12345678-9. Terra es una plataforma tecnológica que ofrece herramientas de software (billetera digital / wallet) para la visualización, gestión y transferencia de activos digitales y criptoactivos por parte de los usuarios. Terra no es una entidad financiera, no capta depósitos del público ni realiza actividades de intermediación financiera en los términos de la Ley N° 21.526, ni está regulada por el Banco Central de la República Argentina (BCRA).
              </p>
            </div>
            <BtnDownloadApp/>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;
